module.exports = __webpack_public_path__ + "img/server.6c59170.png";